import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { ContactUs } from 'experiences/contact'

const Contact: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<ContactUs />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default Contact
